/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/cloud_sync'
export default icon
